
import { useState } from "react"
import SectionHeader from "blocks/SectionHeader"
import NewsModule from "blocks/NewsModule"
import RelatedContent from "../RelatedContent"
import { useFetchStore } from "Fetch"
import { staffIds } from "blocks/People/query"

export default ({ block, module }) => {
  if (block.typeHandle === "profileSelect") {
    return <ProfileSelectModule heading={module.heading} profiles={block.profileSelection} />
  }
  return block.newsEntryType ?
    <RelatedContent color="white" heading={module.heading} type={block.newsEntryType} limit={6} hasSearchBar={module.hasSearchBar} />
    : <StoryModule heading={module.heading} block={block} hasSearchBar={module.hasSearchBar} />

}

const ProfileSelectModule = ({ heading, profiles = [] }) => {
  const limit = 6
  const [offset, setOffset] = useState(limit)
  const validProfiles = profiles.filter((profile) => profile && profile.id)

  return <section className="pad-top pad-bottom max-width">
    <SectionHeader heading={heading} />
    <ul className="grid grid--33">
      {validProfiles.slice(0, offset).map((article) => {
        return <li key={article.id}>
          <NewsModule article={article} color={"white"} />
        </li>
      })}
    </ul>
    {offset < validProfiles.length ? <div className="center max-width"><button className="button blackBorder" onClick={() => {
      setOffset((currentOffset) => currentOffset + limit)
    }}>Load More</button></div> : null}
  </section>
}

const StoryModule = ({ heading, block, hasSearchBar }) => {
  const staffids = useFetchStore(staffIds, "staff")
  let ids = staffids ? staffids.entries.map(per => parseInt(per.id)) : null

  return ids && block.storyType === "staffStory" ?
    <RelatedContent color="white" heading={heading} type={"story"} limit={6} relatedTo={ids} hasSearchBar={hasSearchBar} /> :
    <RelatedContent color="white" heading={heading} type={"story"} limit={6} hasSearchBar={hasSearchBar} />
}